import { vatPrice } from '../helper/price'

function setGtag(type, event, data = {}) {
  if (typeof gtag !== 'undefined' && gtag) {
    gtag(type, event, data)
  }
}

function setFbq(type, event, data = {}) {
  if (typeof fbq !== 'undefined' && fbq) {
    fbq(type, event, data)
  }
}

function productVariants(product) {
  let variants = []

  product.parameters.forEach((parameter) => {
    if (parameter.parameters) {
      parameter.parameters.forEach((parameterItem) => {
        if (parameterItem.name) {
          variants.push(`${parameterItem.name}: ${parameterItem.value}`)
        } else {
          variants.push(parameterItem.value)
        }
      })
    } else {
      if (parameter.name) {
        variants.push(`${parameter.name}: ${parameter.value}`)
      } else {
        variants.push(parameter.value)
      }
    }
  })

  return variants.join(', ')
}

function productBrand(product) {
  let brandName = ''
  if (product.maker && product.maker.name) {
    brandName = product.maker.name
  }

  return brandName
}

function productCategory(product) {
  const categoryNames = []

  product.categories.forEach((category) => {
    categoryNames.push(category.name)
  })

  return categoryNames.join(', ')
}

/**
 *
 * @param product
 */
export function shopAnalyticsViewItem(product) {
  if (!product) {
    return false
  }

  let price = vatPrice(product.price, product.vat)

  if (product.client_price) {
    price = vatPrice(product.client_price, product.vat)
  }

  if (product.discount_price) {
    price = vatPrice(product.discount_price, product.vat)
  }

  setGtag('event', 'view_item', {
    event_label: 'VIEW ITEM',
    items: [
      {
        id: product.product_code || product.id,
        name: product.name,
        brand: productBrand(product),
        category: productCategory(product),
        variant: productVariants(product),
        list_position: 1,
        price: price,
      },
    ],
  })

  setFbq('track', 'ViewContent', {
    content_name: product.name,
    content_category: productCategory(product),
    content_ids: [product.product_code || product.id],
    content_type: 'product',
    value: price,
    currency: 'EUR',
  })
}

/**
 *
 * @param products
 * @returns {boolean}
 */
export function shopAnalyticsViewItems(products) {
  if (!products.length) {
    return false
  }

  const collect = []
  products.forEach((product, listIndex) => {
    let price = vatPrice(product.price, product.vat)

    if (product.client_price) {
      price = vatPrice(product.client_price, product.vat)
    }

    if (product.discount_price) {
      price = vatPrice(product.discount_price, product.vat)
    }

    collect.push({
      id: product.product_code || product.id,
      name: product.name,
      brand: productBrand(product),
      category: productCategory(product),
      variant: productVariants(product),
      list_name: 'VIEW ITEMS LIST',
      list_position: listIndex + 1,
      price: price,
    })
  })

  setGtag('event', 'view_item_list', {
    event_label: 'VIEW ITEMS LIST',
    items: collect,
  })
}

/**
 *
 * @param product
 */
export function shopAnalyticsAddToBasket(product) {
  setGtag('event', 'add_to_cart', {
    event_label: 'ADD TO CART',
    items: [
      {
        id: product.productCode || product.productID,
        name: product.productName,
        brand: productBrand(product),
        category: productCategory(product),
        variant: productVariants(product),
        list_position: 1,
        price: vatPrice(
          product.clientPrice || product.discountPrice || product.price,
          product.vat
        ),
        quantity: product.amount || 1,
      },
    ],
  })
  setFbq('track', 'AddToCart', {
    content_name: product.productName,
    content_category: productCategory(product),
    content_ids: [product.productCode || product.productID],
    content_type: 'product',
    value: vatPrice(
      product.clientPrice || product.discountPrice || product.price,
      product.vat
    ),
    currency: 'EUR',
  })
}

/**
 *
 * @param product
 */
export function shopAnalyticsRemoveFromBasket(product) {
  setGtag('event', 'remove_from_cart', {
    event_label: 'REMOVE FROM CART',
    items: [
      {
        id: product.productCode || product.productID,
        name: product.productName,
        brand: productBrand(product),
        category: productCategory(product),
        variant: productVariants(product),
        list_position: 1,
        price: vatPrice(
          product.clientPrice || product.discountPrice || product.price,
          product.vat
        ),
        quantity: product.amount || 1,
      },
    ],
  })
  setFbq('track', 'RemoveFromCart', {
    content_name: product.productName,
    content_category: productCategory(product),
    content_ids: [product.productCode || product.productID],
    content_type: 'product',
    value: vatPrice(
      product.clientPrice || product.discountPrice || product.price,
      product.vat
    ),
    currency: 'EUR',
  })
}

/**
 *
 * @param items
 * @param bonusCode
 */
export function shopAnalyticsBeginCheckout({ items = [], bonusCode = '' }) {
  const collectItems = []
  items.forEach((product, productIndex) => {
    collectItems.push({
      id: product.productCode || product.productID,
      name: product.productName,
      brand: productBrand(product),
      category: productCategory(product),
      variant: productVariants(product),
      list_position: productIndex + 1,
      price: vatPrice(
        product.clientPrice || product.discountPrice || product.price,
        product.vat
      ),
      quantity: product.amount || 1,
    })
  })

  setGtag('event', 'begin_checkout', {
    event_label: 'BEGIN CHECKOUT',
    items: collectItems,
    coupon: bonusCode,
  })
}

/**
 *
 * @param items
 * @param bonusCode
 */
export function shopAnalyticsCheckoutProgress({ items = [], bonusCode = '' }) {
  const collectItems = []
  items.forEach((product, productIndex) => {
    collectItems.push({
      id: product.productCode || product.productID,
      name: product.productName,
      brand: productBrand(product),
      category: productCategory(product),
      variant: productVariants(product),
      list_position: productIndex + 1,
      price: vatPrice(
        product.clientPrice || product.discountPrice || product.price,
        product.vat
      ),
      quantity: product.amount || 1,
    })
  })

  setGtag('event', 'checkout_progress', {
    event_label: 'CHECKOUT PROGRESS',
    items: collectItems,
    coupon: bonusCode,
  })
}

/**
 *
 * @param basketId
 * @param affiliation
 * @param totalPrice
 * @param totalVat
 * @param transportPrice
 * @param items
 */
export function shopAnalyticsPurchase({
  basketId,
  affiliation = '',
  totalPrice = 0,
  totalVat = 0,
  transportPrice = 0,
  items = [],
}) {
  const collectItems = []
  items.forEach((product, productIndex) => {
    collectItems.push({
      id: product.productCode || product.productID,
      name: product.productName,
      brand: productBrand(product),
      category: productCategory(product),
      variant: productVariants(product),
      list_position: productIndex + 1,
      price: vatPrice(
        product.clientPrice || product.discountPrice || product.price,
        product.vat
      ),
      quantity: product.amount || 1,
    })
  })
  setGtag('event', 'purchase', {
    event_label: 'PURCHASE',
    transaction_id: basketId,
    affiliation,
    value: totalPrice,
    currency: 'EUR',
    tax: totalVat,
    shipping: transportPrice,
    items: collectItems,
  })
}
